import React from 'react';
import { Button } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRotateRight } from '@fortawesome/free-solid-svg-icons';
import { startOverButtonStyles } from './styles';

type Props = {
    handleStartOver: () => void;
}

const StartOverButton = ({ handleStartOver }:Props): JSX.Element => {
    return (
        <Button sx={startOverButtonStyles} variant="contained" onClick={handleStartOver}><FontAwesomeIcon icon={faArrowRotateRight} style={{ margin: '0px 2px 2px 0px' }}/> Start Over</Button>
    );
};

export default StartOverButton;
